/**
 * @file SupplierCheckHint.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-07
 * @modified 2026-10-07
 * @description The line under Add Bill's supplier box when the supplier was
 *              taken from the PO (or its supplier group's parent) rather than
 *              read off the invoice (utils/billSupplierDefault): the hint, in
 *              the error colour, and "It's right" to confirm it. Renders
 *              nothing when there is no hint. Styles in CreateBill.css.
 */

import React from 'react';

export default function SupplierCheckHint({ hint, canConfirm = true, onConfirm }) {
  if (!hint) return null;
  return (
    <p className="supplier-check-hint" role="status">
      <span className="material-symbols-rounded" aria-hidden="true">error</span>
      <span>{hint}</span>
      {canConfirm && (
        <button type="button" className="address-update-link" onClick={onConfirm}>
          <span className="material-symbols-rounded" aria-hidden="true">check</span>
          It&apos;s right
        </button>
      )}
    </p>
  );
}
